// Resources
import React, { Component } from "react";

// Components
import AuthHelperMethods from "../auth/AuthHelperMethods";
import { Prompt } from "./Prompt";
import { Images } from "../function/Images"

// Styles
import { AddImageWrapperEl } from "./styles/AddImageWrapper";


class AddImageWrapper extends Component {
    Auth = new AuthHelperMethods();

    constructor(props) {
        super(props);
        this.state = {
            prompt: "",
            promptColor: "red",
            title: "",
            type: "",
            images: [],
            processing: false,
            processingMsg: "",
            loading: false,
            isValidForm: false,
            isCollapsed: false
        };
    }
    _handleCancel = () => {
        if (this.state.loading) {
            alert("Upload in progress. Unable to close.");
        } else {
            this.state.images.forEach((img) => URL.revokeObjectURL(img.url));
            this.props.handleCancel();
        }
    };
    _handleCollapse = () => {
        this.setState(({ isCollapsed }) => ({ isCollapsed: !isCollapsed }));
    }
    _handleChange = (e) => {
        this.setState(
            { [e.target.name]: e.target.value },
            this.validateForm
        );
    };
    _onDrop = (files) => {
        if (files && files.length > 0) {
            // Validate file formats
            for (let i = 0; i < files.length; i++) {
                if (files[i].type !== "image/jpeg" && files[i].type !== "image/png") {
                    return alert("Invalid file format detected");
                }
            }

            // Revoke old preview if replacing
            const newImages = files.map((file) => ({
                url: URL.createObjectURL(file),
                file: file,
                name: file.name
            }));

            this.setState((prevState) => ({
                images: [...prevState.images, ...newImages]
            }), this.validateForm);
        }
    };
    _handleImageZoom = (img) => {
        console.log("Zoom Image:", img);
    };
    _handleRemoveImage = (index) => {
        URL.revokeObjectURL(this.state.images[index].url);
        this.setState((prevState) => ({
            images: prevState.images.filter((_, i) => i !== index)
        }), this.validateForm);
    };
    _handleImageRename = (index, newName) => {
        this.setState((prevState) => ({
            images: prevState.images.map((img, i) => i === index 
            ? {...img, name: newName} :img)
        }))
    }
    _handleSubmit = async () => {
        this.setState({ loading: true });
        try {
            for (let i = 0; i < this.state.images.length; i++) {
                const formData = new FormData();
                formData.append("image", this.state.images[i].file);
                formData.append("title", this.state.images[i].name);

                const res = await this.Auth.uploadDocsImage(formData);
                if (res.url) {
                    this.props.handleImageInsert(res.url, this.state.images[i].name);
                }
            }

            this.setState({ loading: false });
            this.props.handleCancel();
        } catch (err) {
            console.log("Upload error", err);
            this.displayPrompt("Upload Failed");
            this.setState({ loading: false });
        }
    };
    displayPrompt = (prompt, color) => {
        this.setState({
            prompt: prompt,
            promptColor: color || "red"
        });
    };
    validateForm = () => {
        this.setState({
            isValidForm: this.state.images.length > 0
        });
    };




    render() {
        return (
            <React.Fragment>
                <AddImageWrapperEl className={this.state.isCollapsed ? "collapsed" : ""}>
                    {/* ----- Buttons + Prompt Title ----- */}
                    <div className="header">
                        <div className="cancel-btn" onClick={this._handleCancel}>
                            <span>&#10005;</span>
                        </div>
                        <div className="collapse_toggle" onClick={this._handleCollapse}>
                            {this.state.isCollapsed === true ? (<span>&#43;</span>) : (<span>&#8722;</span>)}
                        </div>

                        <div className="title-wrapper">
                            <h1>
                                Upload Image
                            </h1>
                        </div>
                    </div>
                    {/* ----- Dropzone + Submit + Prompt----- */}
                    {!this.state.isCollapsed && (
                        <>
                            {/* ----- Dropzone ----- */}
                            <div className="field-wrapper">
                                <Images
                                    _onDrop={this._onDrop}
                                    images={[]}
                                    processing={this.state.processing}
                                    processingMsg={this.state.processingMsg}
                                    handleImageZoom={this._handleImageZoom}
                                    length={this.state.images.length}
                                    reader={false}
                                />
                                {this.state.images.length > 0 && (
                                    <div className="preview-list">
                                        {this.state.images.map((img, index) => (
                                            <div key={index} alt={img.name} className="preview-item">
                                                <img src={img.url} alt={img.name} />
                                                <input
                                                    type="text"
                                                    value={img.name}
                                                    onChange={(e) => this._handleImageRename(index, e.target.value)}
                                                />
                                                <button onClick={() => this._handleRemoveImage(index)}>
                                                    &#10005;
                                                </button>
                                            </div>))}
                                    </div>
                                )}

                            </div>

                            {/* ----- SUBMIT ----- */}
                            {this.state.isValidForm && (
                                <button
                                    className={"btn btn-block submit-btn" + (this.state.loading ? " loading" : "")}
                                    onClick={this._handleSubmit}
                                    disabled={this.state.loading}>
                                    {this.state.loading
                                        ? "Uploading..."
                                        : `Add ${this.state.images.length} Image${this.state.images.length > 1 ? "s" : ""}`
                                    }
                                </button>
                            )}

                            {/* ----- PROMPT ----- */}
                            <div className="error-wrapper">
                                {this.state.prompt.length > 0 && (
                                    <Prompt message={this.state.prompt} color={this.state.promptColor} />
                                )}
                            </div>
                        </>
                    )}
                </AddImageWrapperEl>
            </React.Fragment >
        );
    }
}

// export default connect(mapStateToProps)(AddImageWrapper);
export default AddImageWrapper;
